// source: score.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var user_pb = require('./user_pb.js');
goog.object.extend(proto, user_pb);
var activity_pb = require('./activity_pb.js');
goog.object.extend(proto, activity_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.activity.BodypartScore', null, global);
goog.exportSymbol('proto.activity.UserScore', null, global);
goog.exportSymbol('proto.activity.UserScoreBodypart', null, global);
goog.exportSymbol('proto.activity.UserScores', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.UserScoreBodypart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.activity.UserScoreBodypart.repeatedFields_, null);
};
goog.inherits(proto.activity.UserScoreBodypart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.UserScoreBodypart.displayName = 'proto.activity.UserScoreBodypart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.BodypartScore = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.BodypartScore, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.BodypartScore.displayName = 'proto.activity.BodypartScore';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.UserScores = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.activity.UserScores.repeatedFields_, null);
};
goog.inherits(proto.activity.UserScores, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.UserScores.displayName = 'proto.activity.UserScores';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.UserScore = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.UserScore, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.UserScore.displayName = 'proto.activity.UserScore';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.activity.UserScoreBodypart.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.UserScoreBodypart.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.UserScoreBodypart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.UserScoreBodypart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.UserScoreBodypart.toObject = function(includeInstance, msg) {
  var f, obj = {
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f),
bodypartscoresList: jspb.Message.toObjectList(msg.getBodypartscoresList(),
    proto.activity.BodypartScore.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.UserScoreBodypart}
 */
proto.activity.UserScoreBodypart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.UserScoreBodypart;
  return proto.activity.UserScoreBodypart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.UserScoreBodypart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.UserScoreBodypart}
 */
proto.activity.UserScoreBodypart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 2:
      var value = new proto.activity.BodypartScore;
      reader.readMessage(value,proto.activity.BodypartScore.deserializeBinaryFromReader);
      msg.addBodypartscores(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.UserScoreBodypart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.UserScoreBodypart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.UserScoreBodypart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.UserScoreBodypart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
  f = message.getBodypartscoresList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.activity.BodypartScore.serializeBinaryToWriter
    );
  }
};


/**
 * optional users.UserData user = 1;
 * @return {?proto.users.UserData}
 */
proto.activity.UserScoreBodypart.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 1));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.activity.UserScoreBodypart} returns this
*/
proto.activity.UserScoreBodypart.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.activity.UserScoreBodypart} returns this
 */
proto.activity.UserScoreBodypart.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.UserScoreBodypart.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated BodypartScore bodypartScores = 2;
 * @return {!Array<!proto.activity.BodypartScore>}
 */
proto.activity.UserScoreBodypart.prototype.getBodypartscoresList = function() {
  return /** @type{!Array<!proto.activity.BodypartScore>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.activity.BodypartScore, 2));
};


/**
 * @param {!Array<!proto.activity.BodypartScore>} value
 * @return {!proto.activity.UserScoreBodypart} returns this
*/
proto.activity.UserScoreBodypart.prototype.setBodypartscoresList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.activity.BodypartScore=} opt_value
 * @param {number=} opt_index
 * @return {!proto.activity.BodypartScore}
 */
proto.activity.UserScoreBodypart.prototype.addBodypartscores = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.activity.BodypartScore, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.activity.UserScoreBodypart} returns this
 */
proto.activity.UserScoreBodypart.prototype.clearBodypartscoresList = function() {
  return this.setBodypartscoresList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.BodypartScore.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.BodypartScore.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.BodypartScore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.BodypartScore.toObject = function(includeInstance, msg) {
  var f, obj = {
bodypartname: jspb.Message.getFieldWithDefault(msg, 1, ""),
score: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.BodypartScore}
 */
proto.activity.BodypartScore.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.BodypartScore;
  return proto.activity.BodypartScore.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.BodypartScore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.BodypartScore}
 */
proto.activity.BodypartScore.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBodypartname(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScore(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.BodypartScore.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.BodypartScore.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.BodypartScore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.BodypartScore.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBodypartname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getScore();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string bodypartName = 1;
 * @return {string}
 */
proto.activity.BodypartScore.prototype.getBodypartname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.BodypartScore} returns this
 */
proto.activity.BodypartScore.prototype.setBodypartname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 score = 2;
 * @return {number}
 */
proto.activity.BodypartScore.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.BodypartScore} returns this
 */
proto.activity.BodypartScore.prototype.setScore = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.activity.UserScores.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.UserScores.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.UserScores.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.UserScores} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.UserScores.toObject = function(includeInstance, msg) {
  var f, obj = {
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f),
usersscoresList: jspb.Message.toObjectList(msg.getUsersscoresList(),
    proto.activity.UserScore.toObject, includeInstance),
daylength: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.UserScores}
 */
proto.activity.UserScores.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.UserScores;
  return proto.activity.UserScores.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.UserScores} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.UserScores}
 */
proto.activity.UserScores.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 2:
      var value = new proto.activity.UserScore;
      reader.readMessage(value,proto.activity.UserScore.deserializeBinaryFromReader);
      msg.addUsersscores(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDaylength(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.UserScores.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.UserScores.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.UserScores} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.UserScores.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
  f = message.getUsersscoresList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.activity.UserScore.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional users.UserData user = 1;
 * @return {?proto.users.UserData}
 */
proto.activity.UserScores.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 1));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.activity.UserScores} returns this
*/
proto.activity.UserScores.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.activity.UserScores} returns this
 */
proto.activity.UserScores.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.UserScores.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated UserScore usersScores = 2;
 * @return {!Array<!proto.activity.UserScore>}
 */
proto.activity.UserScores.prototype.getUsersscoresList = function() {
  return /** @type{!Array<!proto.activity.UserScore>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.activity.UserScore, 2));
};


/**
 * @param {!Array<!proto.activity.UserScore>} value
 * @return {!proto.activity.UserScores} returns this
*/
proto.activity.UserScores.prototype.setUsersscoresList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.activity.UserScore=} opt_value
 * @param {number=} opt_index
 * @return {!proto.activity.UserScore}
 */
proto.activity.UserScores.prototype.addUsersscores = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.activity.UserScore, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.activity.UserScores} returns this
 */
proto.activity.UserScores.prototype.clearUsersscoresList = function() {
  return this.setUsersscoresList([]);
};


/**
 * optional int32 DayLength = 3;
 * @return {number}
 */
proto.activity.UserScores.prototype.getDaylength = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.UserScores} returns this
 */
proto.activity.UserScores.prototype.setDaylength = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.activity.UserScores} returns this
 */
proto.activity.UserScores.prototype.clearDaylength = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.UserScores.prototype.hasDaylength = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.UserScore.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.UserScore.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.UserScore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.UserScore.toObject = function(includeInstance, msg) {
  var f, obj = {
user: (f = msg.getUser()) && user_pb.UserData.toObject(includeInstance, f),
score: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
scoreday: (f = msg.getScoreday()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.UserScore}
 */
proto.activity.UserScore.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.UserScore;
  return proto.activity.UserScore.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.UserScore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.UserScore}
 */
proto.activity.UserScore.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new user_pb.UserData;
      reader.readMessage(value,user_pb.UserData.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setScore(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setScoreday(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.UserScore.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.UserScore.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.UserScore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.UserScore.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      user_pb.UserData.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getScoreday();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional users.UserData user = 1;
 * @return {?proto.users.UserData}
 */
proto.activity.UserScore.prototype.getUser = function() {
  return /** @type{?proto.users.UserData} */ (
    jspb.Message.getWrapperField(this, user_pb.UserData, 1));
};


/**
 * @param {?proto.users.UserData|undefined} value
 * @return {!proto.activity.UserScore} returns this
*/
proto.activity.UserScore.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.activity.UserScore} returns this
 */
proto.activity.UserScore.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.UserScore.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 score = 2;
 * @return {number}
 */
proto.activity.UserScore.prototype.getScore = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.UserScore} returns this
 */
proto.activity.UserScore.prototype.setScore = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.activity.UserScore} returns this
 */
proto.activity.UserScore.prototype.clearScore = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.UserScore.prototype.hasScore = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp scoreDay = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.activity.UserScore.prototype.getScoreday = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.activity.UserScore} returns this
*/
proto.activity.UserScore.prototype.setScoreday = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.activity.UserScore} returns this
 */
proto.activity.UserScore.prototype.clearScoreday = function() {
  return this.setScoreday(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.UserScore.prototype.hasScoreday = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.activity);
